import { getChallengesRequest } from "../../Redux/ChallengeMain/ChallengeMainActions";
import { toast } from "sonner";
import { axiosReq } from "utils";
import { getStageDetails } from "../../Redux/ChallengeOverview/ChallengeOverviewAction";
import { ChallengeRulesActions } from "./ChallengeRulesReducer";

//get challenge types
export const getChallengeRules = (getToken, id) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeRulesActions.getRulesRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/challenge/challengeRulesDetails/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    dispatch(ChallengeRulesActions.getRulesSuccess(response?.data));
  } catch (error) {
    dispatch(
      ChallengeRulesActions.getRulesErrors(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(clearStates());
};

export const getChartsHistory = (getToken, id) => async (dispatch) => {
  try {
    const token = await getToken();

    dispatch(ChallengeRulesActions.getHistoryRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/equity/limitedHistoryByLogin/${id}`,
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(ChallengeRulesActions.getHistorySuccess(response?.data));
  } catch (error) {
    dispatch(
      ChallengeRulesActions.getHistoryErrors(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(clearStates());
};

export const payFromWallet =
  (getToken, challengeId, type, setOpen) => async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ChallengeRulesActions.payFromWalletRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/addon/purchase`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: {
          challengeId,
          type,
        },
      });
      dispatch(ChallengeRulesActions.payFromWalletSuccess(response?.data));
      toast.success("Addon purchased successfully!", {
        autoClose: 2000,
        className: "bg-green-opacity text-green",
      });
      setOpen && setOpen(false);
      dispatch(getChallengeRules(getToken, challengeId));
      dispatch(getStageDetails(getToken, challengeId));
      dispatch(getChallengesRequest(getToken));
    } catch (error) {
      toast.error(error.response?.data.message || error?.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeRulesActions.payFromWalletErrors(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };

//purchase Addon
export const purchaseAddon = (getToken, data, setOpen) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeRulesActions.purchaseAddonRequest());
    const response = await axiosReq({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/payable/createAddon`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: data,
    });
    dispatch(ChallengeRulesActions.purchaseAddonSuccess(response?.data));
  } catch (error) {
    toast.error(error.response?.data.message || error?.message, {
      autoClose: 2000,
      className: "bg-red-opacity text-red",
    });
    dispatch(
      ChallengeRulesActions.purchaseAddonErrors(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(clearStates());
};

//stripe purchase
export const stripePurchaseAddon =
  (getToken, data, navigate) => async (dispatch) => {
    const token = await getToken();
    try {
      dispatch(ChallengeRulesActions.stripePurchaseRequest());
      const response = await axiosReq({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/stripe/createAddon`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: data,
      });
      dispatch(ChallengeRulesActions.stripePurchaseSuccess(response?.data));
      navigate("/purchaseAddon/stripe");
    } catch (error) {
      toast.error(error.response?.data.message || error?.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
      dispatch(
        ChallengeRulesActions.stripePurchaseErrors(
          error.response?.data.message || error?.message
        )
      );
    }
    dispatch(clearStates());
  };

//skrill purchase
export const skrillPurchaseAddon = (getToken, data) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeRulesActions.skrillPurchaseRequest());
    const response = await axiosReq({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/payments/skrill/createAddon`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: data,
    });
    dispatch(ChallengeRulesActions.skrillPurchaseSuccess(response?.data));
  } catch (error) {
    toast.error(error.response?.data.message || error?.message, {
      autoClose: 2000,
      className: "bg-red-opacity text-red",
    });
    dispatch(
      ChallengeRulesActions.skrillPurchaseErrors(
        error.response?.data.message || error?.message
      )
    );
  }
  dispatch(clearStates());
};

//clear state
export const clearStates = () => async (dispatch) => {
  setTimeout(() => {
    dispatch(ChallengeRulesActions.clearState());
  }, 3000);
};
